import { ResponsiveBar } from "@nivo/bar";
import PropTypes from "prop-types";
import React from "react";

const BarChartControl = (props: any) => {
	const {
		height,
		minWidth,
		data,
		keys,
		indexBy,
		legendX,
		legendY,
		colors,
		...other
	} = props;
	return (
		<React.Fragment>
			<div
				className="container-fluid my-2 p-2"
				style={{ height: height, minWidth: minWidth }}
			>
				<ResponsiveBar
					data={data}
					keys={keys}
					indexBy={indexBy}
					margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
					padding={0.3}
					valueScale={{ type: "linear" }}
					indexScale={{ type: "band", round: true }}
					colors={colors === undefined ? { scheme: "nivo" } : colors}
					defs={[
						{
							id: "dots",
							type: "patternDots",
							background: "inherit",
							color: "#38bcb2",
							size: 4,
							padding: 1,
							stagger: true,
						},
						{
							id: "lines",
							type: "patternLines",
							background: "inherit",
							color: "#eed312",
							rotation: -45,
							lineWidth: 6,
							spacing: 10,
						},
					]}
					fill={[
						{
							match: {
								id: "fries",
							},
							id: "dots",
						},
						{
							match: {
								id: "sandwich",
							},
							id: "lines",
						},
					]}
					borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
					axisTop={null}
					axisRight={null}
					axisBottom={{
						tickSize: 5,
						tickPadding: 5,
						tickRotation: 0,
						legend: legendX === undefined ? "" : legendX,
						legendPosition: "middle",
						legendOffset: 32,
					}}
					axisLeft={{
						tickSize: 5,
						tickPadding: 5,
						tickRotation: 0,
						legend: legendY === undefined ? "" : legendY,
						legendPosition: "middle",
						legendOffset: -40,
					}}
					labelSkipWidth={12}
					labelSkipHeight={12}
					labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
					// legends={[
					//     {
					//         dataFrom: 'keys',
					//         anchor: 'bottom-right',
					//         direction: 'column',
					//         justify: false,
					//         translateX: 120,
					//         translateY: 0,
					//         itemsSpacing: 2,
					//         itemWidth: 100,
					//         itemHeight: 20,
					//         itemDirection: 'left-to-right',
					//         itemOpacity: 0.85,
					//         symbolSize: 20,
					//         effects: [
					//             {
					//                 on: 'hover',
					//                 style: {
					//                     itemOpacity: 1
					//                 }
					//             }
					//         ]
					//     }
					// ]}
					animate={true}
					motionStiffness={90}
					motionDamping={15}
					{...other}
				></ResponsiveBar>
			</div>
		</React.Fragment>
	);
};
BarChartControl.propTypes = {
	data: PropTypes.array,
	keys: PropTypes.array,
};

export { BarChartControl };
